export default __webpack_public_path__ + "static/media/tick.eb8bc7cf.svg";